import { accountantIbkApi, clientIbkApi } from '@ibk/shared-config';
const buildListContractProductsQuery = ({ contractId, limit, offset, category, }) => ({
    url: `/v1/benefits/contracts/${contractId}/products`,
    method: 'GET',
    params: {
        ...(limit !== undefined ? { limit } : {}),
        ...(offset !== undefined ? { offset } : {}),
        ...(category ? { category } : {}),
    },
});
const transformListContractProductsResponse = (response) => response.result;
export const accountantContractProductsApi = accountantIbkApi.injectEndpoints({
    endpoints: build => ({
        listAccountantEmissorContractProducts: build.query({
            query: buildListContractProductsQuery,
            transformResponse: transformListContractProductsResponse,
        }),
    }),
    overrideExisting: false,
});
export const clientContractProductsApi = clientIbkApi.injectEndpoints({
    endpoints: build => ({
        listClientEmissorContractProducts: build.query({
            query: buildListContractProductsQuery,
            transformResponse: transformListContractProductsResponse,
        }),
    }),
    overrideExisting: false,
});
export const { useListAccountantEmissorContractProductsQuery } = accountantContractProductsApi;
export const { useListClientEmissorContractProductsQuery } = clientContractProductsApi;
